module.exports = __webpack_public_path__ + "img/spoken_read_orign.cefff697.svg";